import { alpha } from "@material-ui/core/styles";
export var createMuiTableRowOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            "&$hover:hover": {
                backgroundColor: palette.type === "dark"
                    ? palette.action.hover
                    : alpha(palette.common.offBlack, palette.action.selectedOpacity), // contrast 1
            },
            "&$selected, &$selected:hover": {
                backgroundColor: undefined,
            },
            "&$selected": {
                backgroundColor: palette.type === "dark"
                    ? palette.action.selected
                    : alpha(palette.common.offBlack, 0.04), // contrast min
            },
        },
    });
};
//# sourceMappingURL=MuiTableRow.js.map